export default function getIsWithinNDay(date: string, numberOfDays: number) {
  const now = new Date();
  const expirationDate = new Date(date);
  const diff = expirationDate.getTime() - now.getTime();

  return diff / (1000 * 60 * 60 * 24) <= numberOfDays;
}
